import * as THREE from 'three';
import { Sky } from 'three/examples/jsm/objects/Sky.js';
import type { ShaderFactory } from './types';

export interface SkyUniforms {
  turbidity: THREE.IUniform<number>;
  rayleigh: THREE.IUniform<number>;
  mieCoefficient: THREE.IUniform<number>;
  mieDirectionalG: THREE.IUniform<number>;
  sunPosition: THREE.IUniform<THREE.Vector3>;
  up: THREE.IUniform<THREE.Vector3>;
}

interface SkyShaderDefinition {
  readonly name: string;
  readonly uniforms: SkyUniforms;
  readonly vertexShader: string;
  readonly fragmentShader: string;
}

export const createSkyShader: ShaderFactory = () => {
  const shader = Sky.SkyShader as SkyShaderDefinition;
  return new THREE.ShaderMaterial({
    name: shader.name,
    uniforms: THREE.UniformsUtils.clone(
      shader.uniforms as unknown as Record<string, THREE.IUniform<unknown>>,
    ),
    vertexShader: shader.vertexShader,
    fragmentShader: shader.fragmentShader,
    side: THREE.BackSide,
    depthWrite: false,
  });
};
